export default {
    Bold: {
        description: 'You\'re a bold visionary! Your vibrant energy and adventurous spirit shine through. Your Cameo vanity reflects your creativity with striking colours and sleek, modern designs that make a statement as unique as you.',
        stockist: '#stockist',
        collection: '#collection',
        images: [
            '/_/img/result-images/bold-hero.png',
            '/_/img/result-images/bold-1.png',
            '/_/img/result-images/bold-3.png',
            '/_/img/result-images/bold-4.png',
            '/_/img/result-images/bold-5.png',
        ]
    },
    Calming: {
        description: 'You\'re a serene soul, finding peace in life\'s quiet moments. Your gentle spirit brings calm wherever you go. Your Cameo vanity reflects this tranquility with soft coastal hues evoking a sense of relaxation in a space that\'s as zen as you are!',
        stockist: '#stockist',
        collection: '#collection',
        images: [
            '/_/img/result-images/calm-hero.png',
            '/_/img/result-images/calm-1.png',
            '/_/img/result-images/calm-2.png',
            '/_/img/result-images/calm-3.png',
            '/_/img/result-images/calm-4.png',
            '/_/img/result-images/calm-5.png',
        ]
    },
    Classic: {
        description: 'You exude timeless elegance and sophistication, a true classic! Your Cameo vanity effortlessly combines natural richness with timeless traditional accents, creating a luxurious statement that reflects your classic style.',
        stockist: '#stockist',
        collection: '#collection',
        images: [
            '/_/img/result-images/classic-hero.png',
            '/_/img/result-images/classic-1.png',
            '/_/img/result-images/classic-2.png',
            '/_/img/result-images/classic-3.png',
            '/_/img/result-images/classic-4.png',
            '/_/img/result-images/classic-5.png',
        ]
    },
    Minimalist: {
        description: 'You value simplicity and functionality. Your Cameo vanity epitomizes minimalist elegance, with neutral tones and clean lines, whilst a hint of colour adds personality. The perfect balance between understated design and individuality.',
        stockist: '#stockist',
        collection: '#collection',
        images: [
            '/_/img/result-images/minimalist-hero.png',
            '/_/img/result-images/minimalist-1.png',
            '/_/img/result-images/minimalist-2.png',
            '/_/img/result-images/minimalist-3.png',
            '/_/img/result-images/minimalist-4.png',
        ]
    },
    Romantic: {
        description: 'You have an eye for beauty in life\'s details, embracing your romantic nature. With its soft pink hues and modern black taps, your Cameo vanity turns your space into an insta-worthy retreat, perfectly suited to your whimsical daydreamer spirit.',
        stockist: '#stockist',
        collection: '#collection',
        images: [
            '/_/img/result-images/romantic-hero.png',
            '/_/img/result-images/romantic-2.png',
            '/_/img/result-images/romantic-3.png',
            '/_/img/result-images/romantic-4.png',
            '/_/img/result-images/romantic-5.png',
        ]
    },
}
